export const buildConfig = 'production';
